import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState = {
    shops: [],
    shop: null,
    loading: false,
    pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 15,
        total: 0
    },
    availableStores:[],
    currentShopId: null
}

export default {
    namespaced: true,

    state: initialState,

    getters: getters,

    actions: actions,

    mutations: mutations
}
